module.exports = __webpack_public_path__ + "img/caricaturista.5ed5bbae.jpg";